export { default } from './VideoInfo';



// WEBPACK FOOTER //
// ./app/components/shelves/ShelfListItem/VideoInfo/index.js